import Contact from "@/components/Contact";

export default function ContactPage() {
  return (
    <main data-testid="page-contact" className="pt-[72px]">
      <Contact />
    </main>
  );
}
